import { MatrixClient, Room } from 'matrix-js-sdk/src/matrix';

import { WORKSPACE_KEY_MGMT_MIN_PL } from 'api/meedioBackend/apiKeys/constants';
import i18n from 'i18n/config';
import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';
import { getUserPowerLevel } from 'utils/matrixUtils';
import getEnabledPermissionsForRole from 'utils/permissions/getEnabledPermissionsForRole';
import { PermissionId, workspacesConfig } from 'utils/powerLevelsConfig';

export enum WorkspaceSettingsTabs {
  General,
  Members,
  Roles,
  ApiKeys,
  SubWorkspaces,
}

export const getWorkspaceName = (matrixClient: MatrixClient, workspaceId?: string) =>
  matrixClient?.getRoom(workspaceId)?.name || i18n.t('workspaces.workspace');

export const getRequiredPowerLevel = (permissionId: PermissionId) => {
  const permission = workspacesConfig[permissionId];
  if (!permission) throw new Error(`Permission ${permissionId} not found`);

  return permission.powerLevel;
};

export const hasWorkspacePermission = (
  workspaceRoom: Room | null,
  userId: string | null,
  permissionId: PermissionId
) => {
  if (!workspaceRoom || !userId) return false;
  const userPowerLevel = getUserPowerLevel(workspaceRoom, userId);

  return userPowerLevel >= getRequiredPowerLevel(permissionId);
};

/** Show Roles tab when the actor can manage roles, or has at least one enabled permission on their assigned role. */
export const shouldShowWorkspaceRolesTab = (adjustRoles: boolean, actorRole: WorkspaceRoleV2 | null): boolean => {
  if (adjustRoles) return true;
  if (!actorRole) return false;

  return getEnabledPermissionsForRole(actorRole).length > 0;
};

/** Show the API keys tab only to workspace admins (PL >= 70); hidden, not disabled, below that. */
export const shouldShowApiKeysTab = (workspacePowerLevel: number): boolean =>
  workspacePowerLevel >= WORKSPACE_KEY_MGMT_MIN_PL;
